
























































import {
  Vue, Component, Mixins, Prop
} from 'vue-property-decorator';
import moment from 'moment';
import MyForm from '@/mixins/form';

import FrozenMoney from './frozenmoney.vue';
import Balance from './balance.vue';

@Component({
  components: {
    FrozenMoney,
    Balance
  }
})
export default class extends Mixins(MyForm) {
  @Prop() userId!: number

  balanceModalVisible = false;

  frozenMoneyModalVisible = false;

  total_deposit = 0

  field = '';

  t = 0;

  depositCate = 0

  deposits: any[] = []

  money = 0

  showBalanceModal(id: number) {
    this.editId = id;
    this.balanceModalVisible = true;
  }

  hideBalanceModal() {
    this.balanceModalVisible = false;
  }

  showFrozenMoneyModal(field: string, t: number, depositCate: number, money: number) {
    this.field = field;
    this.t = t;
    this.depositCate = depositCate;
    this.money = money;
    this.frozenMoneyModalVisible = true;
  }

  hideFrozenMoneyModal() {
    this.frozenMoneyModalVisible = false;
    this.loadList();
    this.handleCancel();
  }

  async loadList() {
    const res = await this.$store.dispatch('users/deposit', {
      user_id: this.userId
    });
    // console.log(res);
    this.total_deposit = 0;
    if (res && res.Data) {
      this.deposits = res.Data;

      for (const obj of res.Data) {
        this.total_deposit += Number(obj.money);
      }
    }
  }

  handleSaveDepositTime(depositCate: number) {
    this.showTsConfirm({
      title: '确认信息',
      content: '你确定要修改解冻时间吗？',
      onOk: async () => {
        const frozenTime = this.form.getFieldValue(`frozen_time${depositCate}`);

        const res = await this.$store.dispatch('users/saveDepositFrozenTime', {
          user_id: this.userId,
          deposit_cate: depositCate,
          frozen_time: moment(frozenTime).format('YYYY-MM-DD HH:mm:ss')
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  mounted() {
    this.loadList();
  }
}
